module.exports = __webpack_public_path__ + "img/13.3120a101.png";